import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { TextField } from 'redux-form-material-ui';

const FullNameField = props => (
  <Field
    name="fullName"
    component={ TextField }
    className="name-field"
    hintText="Enter your full name"
    floatingLabelText="Full name *"
    fullWidth={ true }
    autoComplete="name"
    autoCorrect="off"
    onBlur={ props.onBlur }
    validate={ props.validate }
  />
);

FullNameField.propTypes = {
  validate: PropTypes.func,
  onBlur: PropTypes.func,
};

export default FullNameField;